import BaseMetadata from "./territoryModelMetadataBase.json";

export default class TerritoryModelMetadata {
  constructor(accountsTableDetailsRecord) {
    this.initializeMetadata(accountsTableDetailsRecord);
  }

  initializeMetadata(accountsTableDetailsRecord) {
    this.metadata = BaseMetadata;
    this.addAccountDetails(accountsTableDetailsRecord);
    this.addProductMetricDetailValues(accountsTableDetailsRecord);
  }

  addAccountDetails(accountsTableDetailsRecord) {
    this.metadata.properties.accountData.items.properties.accountDetails.properties = accountsTableDetailsRecord.accountDetailMetadata.reduce(
      (accountDetail, accountDetailMetadata) => {
        accountDetail[accountDetailMetadata.name] = this.formatTypeEnum(
          accountDetailMetadata.type
        );
        return accountDetail;
      },
      {}
    );
  }

  // accountDetailMetadata.type is an enum of [ STRING, BOOLEAN, DATE, DATETIME, NUMBER ]
  formatTypeEnum(typeString) {
    switch (typeString) {
      case "STRING":
        return { type: "string" };
      case "BOOLEAN":
        return { type: "boolean" };
      case "DATE":
        return {
          type: "string",
          format: "date"
        };
      case "DATETIME":
        return {
          type: "string",
          format: "date-time"
        };
      case "NUMBER":
        return {
          type: "number"
        };
      default:
        return {};
    }
  }

  addProductMetricDetailValues(accountsTableDetailsRecord) {
    let typesDict = {};
    let fieldToLabel = {};
    if (accountsTableDetailsRecord.productMetricMetadata.length > 0) {
      accountsTableDetailsRecord.productMetricMetadata.forEach(
        productMetric => {
          fieldToLabel[productMetric.productMetricLabel.name] =
            productMetric.productMetricLabel.label;
          const key = productMetric.productMetricLabel.type;
          if (typesDict[key]) {
            typesDict[key].properties.metric.enum.push(
              productMetric.productMetricLabel.name
            );
          } else {
            typesDict[key] = this.createMetricSchema(productMetric);
          }
        }
      );
    }
    this.metadata.properties.accountData.items.properties.productMetricDetails.items = {
      oneOf: Object.values(typesDict),
      fieldToLabel: fieldToLabel
    };
  }

  createMetricSchema(productMetric) {
    let result = {
      type: "object",
      properties: {
        metric: {
          type: "string"
        },
        productMetricValues: {
          type: "object",
          properties: {}
        }
      }
    };

    result.properties.metric["enum"] = [productMetric.productMetricLabel.name];
    productMetric.productLabels.forEach(product => {
      result.properties.productMetricValues.properties[
        product
      ] = this.formatTypeEnum(productMetric.productMetricLabel.type);
    });
    return result;
  }
}
